import { DELETE } from "../adapters/xhr";
import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

export default function (licenceApplicationId) {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        DELETE(`api/LicenceApplication/DeleteOrphaned/${licenceApplicationId}`)
            .then(() => {
                dispatch({ type: "CLEAR_CURRENT_APPLICATION" });
                dispatch({ type: "CLEAR_CURRENT_VESSEL" });
                dispatch(CreateDataRetrievalEndedAction());
            })
            .catch(() => {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
